import DetailNavRow from './DetailNavRow'

export default DetailNavRow
